var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.01172H115V113.012H5V6.01172Z",
    fill: "url(#paint0_radial_2648_2425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 6.01215H115V113.012H4.99994V6.01215ZM0 118.013H120V1.01221H0V118.013ZM78.6001 42.7123C78.6001 42.3124 78.75 42.1122 79.2002 42.1122H87.0501C87.4499 42.1122 87.6501 42.2622 87.6501 42.7123V82.1625C87.6501 82.5623 87.5501 82.7625 87.0501 82.7625H79.3002C78.8002 82.7625 78.65 82.5125 78.65 82.1125V42.7123H78.6001ZM78.0501 31.3622C78.0501 28.1622 80.3 26.2623 83.1503 26.2623C86.2003 26.2623 88.2502 28.3122 88.2502 31.3622C88.2502 34.6622 86.1003 36.4621 83.0503 36.4621C80.1501 36.4623 78.0501 34.6622 78.0501 31.3622ZM55.5501 59.1624C54.1503 53.6123 50.8503 41.5123 49.6001 35.6622H49.5001C48.45 41.5123 45.8002 51.4122 43.7002 59.1624H55.5501ZM41.6501 67.2625L37.7 82.2625C37.6001 82.6623 37.4501 82.7623 36.9501 82.7623H29.6001C29.1002 82.7623 29 82.6123 29.1002 82.0123L43.3001 32.3121C43.5501 31.4122 43.7 30.6121 43.8 28.1622C43.8 27.8123 43.95 27.6623 44.2 27.6623H54.7C55.05 27.6623 55.1999 27.7623 55.3001 28.1622L71.2 82.1123C71.3 82.5121 71.2 82.7623 70.8001 82.7623H62.5C62.1 82.7623 61.8499 82.6623 61.7501 82.3125L57.65 67.2625H41.6501Z",
    fill: "#FF7F18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2648_2425",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2287 29.9906) scale(83.6001 80.9402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423325",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 117.024,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathIllustrator);
export default __webpack_public_path__ + "static/media/path-illustrator.d61130fab97bba91a982eca8c738aaa5.svg";
export { ForwardRef as ReactComponent };